import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { to: '/freelance-contract-belgium', label: 'Freelance Contract Template België', desc: 'Voor zelfstandigen en freelancers in België' },
  { to: '/nda-template-netherlands', label: 'NDA Template Nederland', desc: 'Geheimhoudingsovereenkomst voor Nederlandse ZZP\'ers' },
  { to: '/freelance-contract-template-benelux', label: 'Contract Generator Benelux', desc: 'Voor freelancers in zowel België als Nederland' },
];

const NetherlandsInternalLinks = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Gerelateerde contract templates</h2>
    <div className="grid md:grid-cols-3 gap-4">
      {links?.map((link, i) => (
        <Link
          key={i}
          to={link?.to}
          className="block p-5 border border-gray-200 rounded-xl bg-white hover:border-[#FF8C00] hover:shadow-md transition-all duration-200 group"
        >
          <p className="font-semibold text-[#2F4E6F] group-hover:text-[#FF8C00] transition-colors mb-1">{link?.label}</p>
          <p className="text-sm text-gray-500">{link?.desc}</p>
        </Link>
      ))}
    </div>
  </section>
);

export default NetherlandsInternalLinks;
